// Filename - pages/Support.js

import React from "react";

const Support = () => {
    return (
        <div className="welcome">
            <table align="center" width="90%">
                <tr align="center">
                    <td align="center">
                        <h3>
                            InfoTrawl Support Information
                        </h3>
                    </td>
                </tr>
            </table>
        </div>
    );
};

export default Support;
